import React, { useState } from 'react';
import classNames from 'classnames';
import SvgIcon from '@home/components/SvgIcon';
import CommonBubble from '@home/components/CommonBubble';
import Abnormal from '@/pages/dashboard/components/Abnormal';
import './index.scss';

/**
 * @property {string} [className] - 额外的 CSS 类名，用于自定义样式。
 * @property {React.CSSProperties} [style] - 内联样式对象，用于自定义样式。
 * @property {string} title - 卡片标题文本。
 * @property {string} [titleTip] - 卡片描述文本，可选。
 * @property {React.ReactNode} [rightSolt] - 卡片右侧插槽内容，可选。
 * @property {AbnormalPropsFace} [normalConfig] - 配置卡片正常状态下的属性，可选。
 */

interface ICardTitleBoxProps {
  className?: string;
  style?: React.CSSProperties;
  title?: React.ReactNode;
  titleTip?: React.ReactNode;
  rightSolt?: React.ReactNode;
  normalConfig?: any;
  children: React.ReactNode;
}

export default (props: ICardTitleBoxProps) => {
  const {
    title,
    className,
    style,
    titleTip,
    rightSolt,
    children,
    normalConfig = { isLoading: false },
  } = props;

  const [isHover, setIsHover] = useState(false);

  return (
    <div
      className={classNames('dbh-studio-card-title-container', className)}
      style={style}
    >
      <div className="dbh-studio-card-title">
        <div className='dbh-studio-card-title-left'>
          {title}
          {titleTip && (
            <CommonBubble dark content={titleTip}>
              <i
                className='dbh-studio-card-title-tip'
                onMouseOver={() => {
                  setIsHover(true);
                }}
                onMouseOut={() => {
                  setIsHover(false);
                }}
              >
                <SvgIcon
                  type={isHover ? 'alert-circle-action' : 'alert-circle-m'}
                />
              </i>
            </CommonBubble>
          )}
        </div>
        <div className='dbh-studio-card-title-right'>{rightSolt}</div>
      </div>
      <div className="dbh-studio-card-content">
        <Abnormal {...normalConfig} component={children} />
      </div>
    </div>
  );
};
